module.exports = __webpack_public_path__ + "static/tekton-6d749f8f9546eca193a1fcc084a6e6b1.png";